export default __webpack_public_path__ + "static/media/3536 spice rack A top.357f8a7f.png";